// extracted by css-extract-rspack-plugin
export default {"list":"_f278dbcb","listHeading":"_457af643","listItem":"_4219a5e"};